import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseSidebarModule } from '@fuse/components';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { AppDirectivesModule } from './shared/directives/app-directives.module';
import { AppComponentsModule } from './shared/components/app-component.module';

@NgModule({
    imports: [

        AppDirectivesModule,

        MatRippleModule,
        MatSelectModule,
        MatMenuModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatAutocompleteModule,

        TranslateModule,

        ToastModule,
        TableModule,


        FuseSidebarModule,
        AppComponentsModule

    ],
    declarations: [],
    exports: [

        AppDirectivesModule,

        MatRippleModule,
        MatSelectModule,
        MatMenuModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatAutocompleteModule,

        TranslateModule,

        ToastModule,
        TableModule,

        FuseSidebarModule,
        AppComponentsModule

    ]
})
export class AppSharedModule { }